import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import useMaxReportModal from '../hooks/useMaxReportModal';
import HeaderText from '../../../../shared/components/HeaderText/HeaderText';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import ReportingModal from '../ReportingModal';
import ActiveReportSidebar from '../ActiveReportSidebar';
import EvaluationReportData from './EvaluationReportData';

const MainContainer = styled('main')`
  flex: ${(props) => (props.isReportOpen ? 50 : 10)};
  margin: 0px 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  
  @media screen and (max-width: 540px) {
    padding: 0px 15px;
    margin: 0px;
  }
`;

const HeaderRow = styled('div')`
  display: flex;
  margin-top: 30px;
  margin-bottom: 40px;
  page-break-before: avoid;

  h1 {
    text-transform: capitalize;
  }

  @media screen and (max-height: 920px) {
    margin-bottom: 20px;
    margin-top: 30px;
  }
`;

const BodyRow = styled('div')`
  display: flex;
  flex-basis: 100%;
  width: 100%;
  overflow: auto;
`;

const MobileActiveMenu = styled('div')`
  position: fixed;
  width: 140px;
  height: 45px;
  bottom: 30px;
  left: 50%;
  margin-left: -70px;
  background-color: white;
  border-radius: 30px;
  display: none;
  box-shadow: ${BoxShadow};
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const EvaluationReport = ({ handlePrint, printRef }) => {
  const {
    handleSetIsModalOpen,
  } = useMaxReportModal();

  const isReportOpen = useSelector((state) => state.reporting.ui.isReportOpen);
  const activeModal = useSelector((state) => state.reporting.ui.activeModal);

  useEffect(() => {
    handleSetIsModalOpen(true, 'evaluation');
  }, []);

  return (
    <MainContainer
      isReportOpen={isReportOpen || activeModal === 'downloadEvaluationReport'}
      ref={printRef}
    >
      <ReportingModal />
      {isReportOpen && (
        <>
          <HeaderRow>
            <HeaderText
              fontWeight={300}
              letterSpacing='normal'
            >
              Evaluation Report
            </HeaderText>
          </HeaderRow>
          <BodyRow id='evalBodyRow'>
            <EvaluationReportData />
          </BodyRow>
          <MobileActiveMenu>
            <ActiveReportSidebar handlePrint={handlePrint} print />
          </MobileActiveMenu>
        </>
      )}
    </MainContainer>
  );
};

EvaluationReport.propTypes = {
  handlePrint: PropTypes.func,
  printRef: PropTypes.shape({
    current: PropTypes.oneOfType([
      PropTypes.instanceOf(Element),
      PropTypes.oneOf([null]),
    ]),
  }),
};

EvaluationReport.defaultProps = {
  handlePrint: () => {},
  printRef: null,
};

export default EvaluationReport;
